import React, { FC, useState, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import CloseIcon from '@mui/icons-material/Close';
import {
    Theme,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    TextField,
    Box,
    IconButton,
    Tooltip,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { StoreModel } from '../models/Index';
import { Services } from 'helpers/constants/Services';
import {
    CashReceivingStatus,
} from '@b2bsoft/kiosk-shell-sdk';

interface CashAcceptorEmulatorProps { }
interface CashAcceptorEmulatorPropsInjected extends CashAcceptorEmulatorProps {
    Store: StoreModel;
}

const useStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            padding: theme.spacing(4),
        },

        footer: {
            justifyContent: 'center',
        },

        emulatorButton: {
            position: 'absolute',
            top: theme.spacing(2),
            left: theme.spacing(2),
        },
    };
});

const CashAcceptorEmulator: FC<CashAcceptorEmulatorProps> = (props) => {
    const {
        Store: { peripheryStatus },
    } = props as CashAcceptorEmulatorPropsInjected;
    const classes = useStyles();
    const [amount, setAmount] = useState(0);
    const [status, setStatus] = useState<CashReceivingStatus>(
        CashReceivingStatus.Idling
    );


    const [open, setOpen] = useState(true);

    useEffect(() => {
        setOpen(Boolean(peripheryStatus.isCashProcessingStarted));
    }, [peripheryStatus.isCashProcessingStarted]);

    const StatusHelper = (
        <Typography variant='body2' color='textSecondary' component='span'>
            {Object.keys(CashReceivingStatus)
                .filter((k) => !isNaN(+k))
                .map((key) => (
                    <Typography key={key}>
                        {key}: {CashReceivingStatus[Number(key)]}
                    </Typography>
                ))}
        </Typography>
    );

    return (
        <>
            {!open && peripheryStatus.isCashProcessingStarted && (
                <Button
                    className={classes.emulatorButton}
                    draggable={true}
                    onClick={() => setOpen(true)}
                    variant='primary'
                >
                    Cash Acceptor Emulator
                </Button>
            )}
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                classes={{ paper: classes.root }}
            >
                <DialogTitle>
                    <Box display='flex' alignItems='center'>
                        <Typography
                            variant='h5'
                            style={{ fontWeight: 'normal' }}
                        >
                            Cash Acceptor emulator
                        </Typography>
                        <IconButton onClick={() => setOpen(false)}>
                            <CloseIcon color='secondary' />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        variant='outlined'
                        label='Amount'
                        type='number'
                        value={amount}
                        onChange={(e) => setAmount(+e.target.value)}
                    />
                    <Box mt={2} />
                    <TextField
                        fullWidth
                        variant='outlined'
                        label='Status'
                        type='number'
                        value={status}
                        onChange={(e) => setStatus(+e.target.value)}
                        helperText={
                            <Tooltip title={StatusHelper}>
                                <Typography component='span'>
                                    See all statuses
                                </Typography>
                            </Tooltip>
                        }
                    />
                </DialogContent>
                <DialogActions className={classes.footer}>
                    <Button
                        variant='primary'
                        onClick={() => {
                                const data = {
                                    'amount': amount,
                                    'docInfo': "",
                                    'statusMessage': "",
                                    'currentStatus': "",
                                };
                                const event = new CustomEvent('BanknoteEscrowedEventRaised', { detail: data });
                                document.dispatchEvent(event);
                        }}
                    >
                        <Typography variant='button'>Insert</Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default inject(Services.STORE)(observer(CashAcceptorEmulator));
